import type { FrontendWidget } from '../types';
import {
  BulletListComponent,
  DEFAULT_BULLET_LIST_COLUMNS,
} from './BulletListComponent';
import type {
  BulletListColumns,
  BulletListConfig,
  BulletListResolved,
} from './types';

const COLUMN_VALUES: readonly string[] = ['1', '2', '3', '4'];

/** The configured count, or the Strapi default for a missing or unknown value. */
const columnsOf = (value: string | undefined): BulletListColumns =>
  value !== undefined && COLUMN_VALUES.includes(value)
    ? (value as BulletListColumns)
    : DEFAULT_BULLET_LIST_COLUMNS;

export const bulletListWidget: FrontendWidget<
  BulletListConfig,
  BulletListResolved
> = {
  componentType: 'widgets.bullet-list',
  displayName: 'Bullet List',
  defaultValues: { columns: DEFAULT_BULLET_LIST_COLUMNS, items: [] },
  ComponentA: BulletListComponent,
  resolveSync: (config) => ({
    // Mirrors the Strapi default, for a row without a value or whose enum
    // was edited out from under us (10.03.03.33 § Business Logic).
    columns: columnsOf(config.columns),
    items: (config.items ?? [])
      .map((item, index) => ({
        // Separate namespaces: a saved entry's id must never collide with an
        // unsaved entry's position (`id: 1` vs. the second entry → both "1").
        key: item.id !== undefined ? `id:${item.id}` : `idx:${index}`,
        text: item.text?.trim() ?? '',
        ...(item.icon ? { icon: item.icon } : {}),
      }))
      .filter((item) => item.text !== ''),
  }),
};
